import React from "react";
import { formatDistanceToNow } from "date-fns";
import { fr, enUS } from "date-fns/locale";
import Rating from "@mui/material/Rating";
import user from "../assets/images/userOther.png";
import { useTranslation } from 'react-i18next';


const ReviewItem = ({ review }) => {
  const { t, i18n } = useTranslation('therapist');
  const locale = i18n.language === 'fr' ? fr : enUS;
  const formattedDate = review.created_at
    ? formatDistanceToNow(new Date(review.created_at), { addSuffix: true, locale })
    : t('unknown_date');

  return review?.creator != null ? (
    <div className="review-item">
      <img
        src={review?.creator.media?.length > 0 ? review?.creator?.media[0]?.original_url : user}
        alt={review?.creator?.firstname}
        className="therapist-image"
      />
      <div>
        <div className="user-review-stars">
          <h4>
            {review?.creator?.firstname || t('anonymous_user')}
          </h4>
          <Rating name="read-only" value={review.rating} precision={0.5} readOnly />
        </div>
        <p className="time-set">{formattedDate}</p>
        <br />
        <p>{review.comment || t('no_comment')}</p>
      </div>
    </div>
  ) : (<div className="review-item">
    <img
      src={user}
      alt={t('anonymous_user')}
      className="therapist-image"
    />
    <div>
      <div className="user-review-stars">
        <h4>
          {t('anonymous_user')}
        </h4>
        <Rating name="read-only" value={review.rating} precision={0.5} readOnly />
      </div>
      <p className="time-set">{formattedDate}</p>
      <br />
      <p>{review.comment || t('no_comment')}</p>
    </div>
  </div>);
};

export default ReviewItem;
